import { Component } from '@angular/core';
import { CaseResultsEditableComponent } from '@app/modules/case/components/case-results/editable/case-results-editable.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { ResultType } from '@app/shared/models/case-result';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { ResultService } from '@app/core/services/result/result.service';
import { AdditionsResultService } from '@app/core/services/result/additions-result.service';

@Component({
    selector: 'case-results-readonly',
    templateUrl: './case-results-readonly.component.html',
    styleUrls: ['./case-results-readonly.component.scss']
})
export class CaseResultsReadonlyComponent extends CaseResultsEditableComponent {

    get graphicClaimAmount(): number {
        return this.result && this.result.calculation.claims_amount_gross || 0;
    }

    get graphicReplacementAmount(): number {
        return this.result && this.result.valuation.result_type_id === ResultType.REPLACEMENT ? this.result.valuation.gross : 0;
    }

    get graphicReducedAmount(): number {
        return this.result && this.result.calculation.reduced_market_value_assessor || 0;
    }

    get graphicSalvageAmount(): number {
        const hasSalvageFurtherResult = this.result && this.result.additions.find(furtherResult => furtherResult.result_type_id === ResultType.PRICE_SALVAGE);
        return hasSalvageFurtherResult ? hasSalvageFurtherResult.gross : 0;
    }

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected resultService: ResultService,
                protected additionsResultService: AdditionsResultService) {
        super(componentServiceBundle, resultService, additionsResultService);
    }

    public booleanAsTranslation(daBoolean: boolean): string {
        const code = daBoolean ? 'common.btn.yes' : (daBoolean === false ? 'common.btn.no' : marker('common.label.not_specified'));
        return this.translateService.instant(code);
    }
}
